import { AccountTypes } from 'svr/lib/Payments/Constants'

export const isUnifiedPaymentResponse = provider =>
  [AccountTypes.NETWORK_REDUX_DIRECT_PURCHASE, AccountTypes.SAFERPAY, AccountTypes.SHIFT_4].indexOf(provider) > -1

export const updatePayloadWithBrowserData = payload => ({
  ...payload,
  browser_utc_time_diff_in_minutes: -new Date().getTimezoneOffset(),
  browser_is_java_enabled: navigator.javaEnabled(),
  browser_language: navigator.language,
  browser_color_depth: window.screen.colorDepth,
  browser_user_agent: navigator.userAgent,
})
